import React from 'react'
import { FormattedMessage } from 'react-intl'
import type { IconProps } from '@vtex/admin-ui'

import type { ProductSkuOfferDeliveryChannel } from '../../../../__generated__/schema-types'

type DeliveryChannelTextProps = {
  deliveryChannel: ProductSkuOfferDeliveryChannel
} & IconProps

export const DeliveryChannelText = ({
  deliveryChannel,
}: DeliveryChannelTextProps) => {
  if (deliveryChannel === 'DELIVERY') {
    return <FormattedMessage id="pdp.sku-availability.delivery.title" />
  }

  if (deliveryChannel === 'PICKUP_IN_POINT') {
    return <FormattedMessage id="pdp.sku-availability.pickup.title" />
  }

  return <FormattedMessage id="pdp.sku-availability.take-away.title" />
}
